var path = 'app/scripts/modules/core/src/validation/validationError.html';
var html = "<div class=\"error-message\"><span class=\"fa fa-exclamation-circle\"></span> {{message}}</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;